<script lang="ts">
  /**
   * This Vue component dynamically renders either an `AdOpsOutbrain` or `ArticleCard` component
   * based on the provided props.
   * It allows the use of a single component in the layout, deferring the decision of which component
   * to render until the last possible moment.
   *
   */
  import { defineComponent, h, computed } from 'vue'
  import type { ExtractPropTypes } from 'vue'
  import { AdOpsOutbrain, ArticleCard } from '#components'
  import type { $Filters } from '../../types'

  const propsOptions = {
    ad: Boolean,
    adType: {
      type: String,
      default: '',
    },
  }

  type ContentCardProps = ExtractPropTypes<typeof propsOptions>

  export default defineComponent({
    props: propsOptions,
    setup(props) {
      const filters: $Filters = useNuxtApp().$filters

      const isOutbrainAd = (props: ContentCardProps) => {
        return (
          props.ad &&
          props.adType === 'native-outbrain' &&
          filters.nativeProvider === 'outbrain'
        )
      }

      // Automatically detect which component to render
      const componentType = computed(() => {
        return isOutbrainAd(props) ? 'ad-ops-outbrain' : 'article-card'
      })

      return () => {
        const Component: Component =
          componentType.value === 'ad-ops-outbrain'
            ? AdOpsOutbrain
            : ArticleCard
        return h(Component, { ...props })
      }
    },
  })
</script>
